import axios from "axios"
const apiBaseUrl = process.env.REACT_APP_APIBASE_URL

//superAdmin/displayallLOBs

export const CreateLOBAPI = async payload => {
  try {
    console.log(payload)
    const data = payload.payload
    const apiToken = JSON.parse(localStorage.getItem("authUser"))
    const headers = {
      "Content-Type": "application/json",
      Authorization: apiToken,
      Accept: "application/json",
      "Cache-Control": "no-cache",
    }

    const response = await axios.post(
      `${apiBaseUrl}/superAdmin/createLOB`,
      data,
      {
        headers,
      }
    )
    return response
  } catch (error) {
    throw error
  }
}

export const ViewLOBAPI = async () => {
  try {
    const response = await axios.get(`${apiBaseUrl}/superAdmin/viewLOB`)
    return response
  } catch (error) {
    throw error
  }
}

export const DeleteLOBAPI = async payload => {
  try {
    const data = payload.payload
    const apiToken = JSON.parse(localStorage.getItem("authUser"))
    const headers = {
      "Content-Type": "application/json",
      Authorization: apiToken,
      Accept: "application/json",
      "Cache-Control": "no-cache",
    }
    const response = await axios.post(
      `${apiBaseUrl}/superAdmin/deleteLOB`,
      data,
      {
        headers,
      }
    )
    return response
  } catch (error) {
    throw error
  }
}
export const UpdateLOBAPI = async payload => {
  try {
    const data = payload.payload
    const apiToken = JSON.parse(localStorage.getItem("authUser"))
    const headers = {
      "Content-Type": "application/json",
      Authorization: apiToken,
      Accept: "application/json",
      "Cache-Control": "no-cache",
    }

    const response = await axios.post(
      `${apiBaseUrl}/superAdmin/updateLOB`,
      data,
      {
        headers,
      }
    )
    return response
  } catch (error) {
    throw error
  }
}

// SUB LOB API
export const CreateSubLOBAPI = async payload => {
  try {
    const data = payload.payload
    const apiToken = JSON.parse(localStorage.getItem("authUser"))
    const headers = {
      "Content-Type": "application/json",
      Authorization: apiToken,
      Accept: "application/json",
      "Cache-Control": "no-cache",
    }

    const response = await axios.post(
      `${apiBaseUrl}/superAdmin/createSubLOB`,
      data,
      {
        headers,
      }
    )
    return response
  } catch (error) {
    throw error
  }
}

export const ViewSubLOBAPI = async () => {
  try {
    const response = await axios.get(`${apiBaseUrl}/superAdmin/viewSubLOB`)
    return response
  } catch (error) {
    throw error
  }
}

export const DeleteSubLOBAPI = async () => {
  try {
    const response = await axios.get(`${apiBaseUrl}/superAdmin/deleteSubLOB`)
    return response
  } catch (error) {
    throw error
  }
}
export const UpdateSubLOBAPI = async payload => {
  try {
    const data = payload.payload
    const apiToken = JSON.parse(localStorage.getItem("authUser"))
    const headers = {
      "Content-Type": "application/json",
      Authorization: apiToken,
      Accept: "application/json",
      "Cache-Control": "no-cache",
    }

    const response = await axios.post(
      `${apiBaseUrl}/superAdmin/updateSubLOB`,
      data,
      {
        headers,
      }
    )
    return response
  } catch (error) {
    throw error
  }
}

// Insurance Company API
export const createInsuranceCompanyAPI = async payload => {
  try {
    const data = payload.payload
    const apiToken = JSON.parse(localStorage.getItem("authUser"))
    const headers = {
      "Content-Type": "application/json",
      Authorization: apiToken,
      Accept: "application/json",
      "Cache-Control": "no-cache",
    }

    const response = await axios.post(
      `${apiBaseUrl}/superAdmin/createInsuranceCompany`,
      data,
      {
        headers,
      }
    )
    return response
  } catch (error) {
    throw error
  }
}

export const ViewInsuranceCompanyAPI = async () => {
  try {
    const response = await axios.get(
      `${apiBaseUrl}/superAdmin/viewInsuranceCompany`
    )
    return response
  } catch (error) {
    throw error
  }
}

export const DeleteInsuranceCompanyAPI = async () => {
  try {
    const response = await axios.get(
      `${apiBaseUrl}/superAdmin/deleteInsuranceCompany`
    )
    return response
  } catch (error) {
    throw error
  }
}
export const UpdateInsuranceCompanyAPI = async payload => {
  try {
    const data = payload.payload
    const apiToken = JSON.parse(localStorage.getItem("authUser"))
    const headers = {
      "Content-Type": "application/json",
      Authorization: apiToken,
      Accept: "application/json",
      "Cache-Control": "no-cache",
    }

    const response = await axios.post(
      `${apiBaseUrl}/superAdmin/updateInsuranceCompany`,
      data,
      {
        headers,
      }
    )
    return response
  } catch (error) {
    throw error
  }
}
